import { render } from "./CtaFooter.vue?vue&type=template&id=247b7823&ts=true"
import script from "./CtaFooter.vue?vue&type=script&lang=ts"
export * from "./CtaFooter.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__